// extracted by mini-css-extract-plugin
export var animation_block = "bottleSlide-module--animation_block--cff9a";
export var bg = "bottleSlide-module--bg--5fcc6";
export var bottle_repeat_1 = "bottleSlide-module--bottle_repeat_1--09560";
export var bottle_repeat_2 = "bottleSlide-module--bottle_repeat_2--df71d";
export var bottle_repeat_3 = "bottleSlide-module--bottle_repeat_3--7a3d4";
export var btl_container = "bottleSlide-module--btl_container--99114";
export var left = "bottleSlide-module--left--b180e";
export var right = "bottleSlide-module--right--fbee1";
export var slideLeft1 = "bottleSlide-module--slide-left-1--eb429";
export var slideLeft2 = "bottleSlide-module--slide-left-2--32158";
export var slideRight = "bottleSlide-module--slide-right--cce5e";